var map = {
	"./messages.ca_ES.json": 151294,
	"./messages.de_DE.json": 931916,
	"./messages.en_US.json": 1095,
	"./messages.es_ES.json": 380710,
	"./messages.fr_FR.json": 955270,
	"./messages.it_IT.json": 243240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 338488;